module.exports = __webpack_public_path__ + "img/WK.ba4b5767.png";